import { WalletContextState } from '@solana/wallet-adapter-react';
import { PublicKey, TransactionInstruction } from '@solana/web3.js';
import * as BufferLayout from '@solana/buffer-layout';
import { u64 } from '@solana/buffer-layout-utils';
import { blob } from '@solana/buffer-layout';
import { MessageSignatureModel, TransferParamsWithToken, IInstructionInputData, InstructionType } from '../models';

export const getWalletAuthentication = async (wallet: WalletContextState | any, message: string): Promise<any> => {
   const messageEncoded = new TextEncoder().encode(`${message}`);

   if (!wallet.signMessage && !wallet?.adapter?._wallet?.signMessage) return;

   if (wallet.signMessage) {
      return await wallet.signMessage(messageEncoded);
   }

   if (wallet?.adapter?._wallet?.signMessage) {
      return await wallet.adapter._wallet.signMessage(messageEncoded);
   }

   return;
};

export const authenticateBySignature = async (message: string, wallet: WalletContextState, tokenId: string) => {
   const signedMessage = await getWalletAuthentication(wallet, `${message}`);
   if (!wallet.publicKey?.toString()) return null;

   const signature: MessageSignatureModel = {
      message: message,
      tokenId: tokenId,
      signer: wallet.publicKey.toString(),
      signature: new Uint8Array(signedMessage.signature ? signedMessage.signature.buffer : signedMessage.buffer)
         .toString()
         .split(',')
         .map(function (item) {
            return parseInt(item, 10);
         }),
   };

   return signature;
};

export function transferFromWeb3(params: TransferParamsWithToken): TransactionInstruction {
   const getTransferWithTokenType = (tokenLength: number) => {
      return {
         index: 2,
         layout: BufferLayout.struct<
            IInstructionInputData & {
               lamports: bigint;
               token: Uint8Array;
            }
         >([BufferLayout.u32('instruction'), u64('lamports'), blob(tokenLength, 'token')]),
      };
   };
   function getAlloc(type: any, fields: any): number {
      let alloc = 0;
      type.layout.fields.forEach((item: any) => {
         if (item.span >= 0) {
            alloc += item.span;
         } else if (typeof item.alloc === 'function') {
            alloc += item.alloc(fields[item.property]);
         }
      });
      return alloc;
   }
   function encodeData<TInputData extends IInstructionInputData>(type: InstructionType<TInputData>, fields?: any): Buffer {
      const allocLength = type.layout.span >= 0 ? type.layout.span : getAlloc(type, fields);
      const data = Buffer.alloc(allocLength);
      const layoutFields = Object.assign({ instruction: type.index }, fields);
      type.layout.encode(layoutFields, data);
      return data;
   }

   let data;
   let keys;
   const type = getTransferWithTokenType(params.token.length);
   data = encodeData(type, { lamports: BigInt(params.lamports), token: params.token });
   keys = [
      { pubkey: params.fromPubkey, isSigner: true, isWritable: true },
      { pubkey: params.toPubkey, isSigner: false, isWritable: true },
   ];

   return new TransactionInstruction({
      keys,
      programId: new PublicKey('11111111111111111111111111111111'),
      data,
   });
}
